import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FolderKanban, Briefcase, Building2, Inbox, Mail } from "lucide-react";
import { api } from "../../lib/api";
import { mediaUrl } from "../../lib/media";

const Stat = ({ label, value, icon: Icon, accent }) => (
  <div data-testid={`stat-${label}`} className="rounded-xl border border-white/5 bg-[#101018] p-5">
    <div className="flex items-center justify-between">
      <span className="text-[10px] tracking-widest uppercase text-white/40 font-mono-ui">{label}</span>
      <Icon size={14} className={accent ? "text-[#A855F7]" : "text-white/40"} />
    </div>
    <div className="mt-4 font-display text-4xl text-white">{value}</div>
  </div>
);

export default function AdminDashboard() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/admin/dashboard").then((r) => setData(r.data)).catch(() => {});
  }, []);
  if (!data) return null;

  return (
    <div>
      <h1 className="font-display text-4xl uppercase tracking-tight text-white mb-2">Genel Bakış</h1>
      <p className="text-white/50 text-sm mb-8">Son güncellemeler ve site durumu.</p>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Stat label="Proje" value={data.counts.projects} icon={FolderKanban} accent />
        <Stat label="Hizmet" value={data.counts.services} icon={Briefcase} />
        <Stat label="Marka" value={data.counts.brands} icon={Building2} />
        <Stat label="Mesaj" value={data.counts.messages} icon={Mail} accent />
      </div>

      <div className="mt-4 grid grid-cols-2 md:grid-cols-4 gap-4">
        <Stat label="Okunmamış" value={data.counts.unread} icon={Inbox} accent />
      </div>

      <div className="mt-10 grid lg:grid-cols-2 gap-6">
        <div className="rounded-xl border border-white/5 bg-[#101018] p-5">
          <h3 className="text-sm uppercase tracking-widest text-white/50 mb-4 font-mono-ui">Son Projeler</h3>
          <ul className="space-y-3">
            {data.recent_projects.map((p) => (
              <li key={p.id} className="flex items-center gap-3">
                <img src={mediaUrl(p.cover_image)} alt="" className="w-10 h-10 rounded-md object-cover" />
                <div className="flex-1">
                  <div className="text-white text-sm">{p.title_tr}</div>
                  <div className="text-white/40 text-xs">{p.brand_name}</div>
                </div>
                <Link to="/admin/projects" className="text-[#A855F7] text-xs">→</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="rounded-xl border border-white/5 bg-[#101018] p-5">
          <h3 className="text-sm uppercase tracking-widest text-white/50 mb-4 font-mono-ui">Son Mesajlar</h3>
          <ul className="space-y-3">
            {data.recent_messages.length === 0 && (
              <li className="text-white/40 text-sm">Henüz mesaj yok.</li>
            )}
            {data.recent_messages.map((m) => (
              <li key={m.id} className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full bg-[#A855F7]/20 border border-[#A855F7]/30 flex items-center justify-center text-[10px] text-[#A855F7]">
                  {m.name[0]}
                </div>
                <div className="flex-1">
                  <div className="text-white text-sm">{m.name} <span className="text-white/40">· {m.company || "—"}</span></div>
                  <div className="text-white/40 text-xs truncate max-w-[300px]">{m.message}</div>
                </div>
                <Link to="/admin/messages" className="text-[#A855F7] text-xs">→</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
